import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { BlogListingPage } from '~/pages/blog';

const blogSchema = z.object({
  category: z.string().optional(),
  page: z.coerce.number().int().min(1).optional(),
  /** The slug of an article that doesn't exist in this language (the redirect from its address). */
  missing: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/blog')({
  validateSearch: blogSchema,
  component: BlogRoute,
});

function BlogRoute() {
  const { category, page, missing } = Route.useSearch();

  return <BlogListingPage category={category} page={page ?? 1} missing={missing} />;
}
